import ChipField from './ChipField';
import { ChipFieldProps, ChipFieldValueProps } from './types';

export type { ChipFieldProps, ChipFieldValueProps };
export default ChipField;
